import { render, staticRenderFns } from "./ProfileZoom.vue?vue&type=template&id=7a390770&scoped=true&"
import script from "./ProfileZoom.vue?vue&type=script&lang=js&"
export * from "./ProfileZoom.vue?vue&type=script&lang=js&"
import style0 from "./ProfileZoom.vue?vue&type=style&index=0&id=7a390770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a390770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VRow})
